<template>
  <div class="body">
    <div class="subscribe-container">
      <div class="subscribe-content">
        <h3 class="subscribe-title">
          {{ $t(`message.subscription.subscribeTitle`) }}
        </h3>
        <p>
          {{ $t(`message.subscription.subscribeContent`) }}
        </p>
        <p class="subscribe-price">
          {{ $t(`message.subscription.subscribePrice`) }}
          <span class="price-box">{{ price }}</span>
        </p>
        <p class="subscribe-extend-date">
          <span v-if="resubscription !== null">
            {{ $t(`message.subscription.resubscribeExtendDate`) }}
            {{ $d(resubscription, "shortDate") }}
          </span>
        </p>
        <form
          name="paymentForm"
          id="paymentForm"
          method="POST"
          :action="paymentUrl"
        >
          <input type="hidden" name="MerchantID" :value="merchantId" />
          <input type="hidden" name="Len" :value="paymentParamLen" />
          <input type="hidden" name="Data" :value="paymentParamData" />
          <input type="hidden" name="CustomField1" :value="paymentAmount" />
        </form>
      </div>
      <div class="row actions-area">
        <div class="input-group col button-container">
          <button class="pill" @click="subscribe">
            {{ $t(`message.payment.proceedPayment`) }}
          </button>
        </div>
        <div class="input-group col button-container">
          <button class="pill" @click="$router.push({ name: 'PersonalHome' })">
            {{ $t(`message.cancel`) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSubscription",
  data() {
    return {
      merchantId: null,
      paymentUrl: null,
      paymentParamData: null,
      paymentParamLen: null,
      paymentAmount: null,
      currencies: {
        EUR: "€",
        USD: "$",
        AUR: "$",
        GBP: "£",
      },
    };
  },
  methods: {
    subscribe: function () {
      if (this.$store.getters["users/isTeacher"]) {
        this.$router.push({ name: "PersonalHome" });
        this.$store.dispatch(
          "notifications/addError",
          {
            message: this.$t(`message.notifications.alreadySubscribed`),
          },
          { root: true },
        );
      } else {
        this.$store
          .dispatch("subscriptions/subscribe", {
            email: this.$store.state.users.user.email,
          })
          .then((res) => {
            // Prepare payment form
            this.paymentUrl = res.data.payment_url;
            this.merchantId = res.data.merchant_id;
            this.paymentParamData = res.data.payment_data;
            this.paymentParamLen = res.data.payment_data_len;

            const amount = (res.data.payment_amount / 100).toLocaleString(
              this.$i18n.locale,
              { minimumFractionDigits: 2 },
            );

            // payment page customization
            const currency =
              this.currencies[res.data.payment_currency] ||
              res.data.payment_currency;
            this.paymentUrl += `?CustomField1=${amount}+${currency}`;

            // Submit & go to payment page
            this.$nextTick(() => {
              this.$el.querySelector("#paymentForm").submit();
            });
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 409) {
              this.$router.push({ name: "PersonalHome" });
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(`message.notifications.paymentAlreadyDone`),
                },
                { root: true },
              );
            } else {
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(`message.notifications.paymentError`),
                },
                { root: true },
              );
            }
          })
          .finally(() => {
            this.$store.dispatch(
              "loadings/disableLoadings",
              {},
              { root: true },
            );
          });
      }
    },
  },
  computed: {
    price() {
      let subscriptionPrice =
        this.$store.getters["users/getCountry"].subscription_price;
      const currency = this.$store.getters["users/getCountry"].currency;
      if (subscriptionPrice != null) {
        subscriptionPrice = subscriptionPrice.toLocaleString(
          this.$i18n.locale,
          { minimumFractionDigits: 2 },
        );
      }

      return `${subscriptionPrice}${currency}`;
    },
    subscriptionExpiry() {
      if (this.$store.state.users.user.subscription_expiry === null) {
        return null;
      } else {
        return new Date(this.$store.state.users.user.subscription_expiry);
      }
    },
    resubscription() {
      const today = new Date().getTime();
      const expirationdate = new Date(
        this.$store.state.users.user.subscription_expiry,
      );
      const daysleft = expirationdate.getTime();
      // If the subscription is expired, we set the resubscription date to today + 1 years
      const refDate = today > daysleft ? today : daysleft;
      const dayslefts = refDate + 60 * 60 * 8760 * 1000;

      if (this.subscriptionExpiry !== null) {
        return dayslefts;
      } else {
        return null;
      }
    },
  },
  mounted() {
    if (import.meta.env.VITE_GAR == "true") {
      this.$router.push({ name: "PersonalHome" });
    } else {
      this.$store.dispatch("users/getLocalization");
    }
  },
};
</script>

<style lang="scss" scoped>
.body {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 100px - 126px - 40px);

  .subscribe-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("../assets/subscription/planet-background.webp");
    background-size: cover;
    border-radius: 50px;
    width: 90%;
    padding-left: 6em;
    padding-right: 6em;
    min-height: 400px;
    margin-bottom: 40px;
    text-align: center;

    .subscribe-title {
      margin-bottom: 3rem;
      text-transform: uppercase;
      font-family: "Averia Sans Libre", sans-serif;
      font-weight: 800;
    }

    .subscribe-price {
      font-weight: 700;
    }

    .subscribe-extend-date {
      padding-bottom: 2em;
    }

    .price-box {
      background-color: white;
      border-radius: 8px;
      padding: 0.3em;
      margin: 0.3em;
      margin-bottom: 0.3em;
    }

    .actions-area {
      width: 140%;
      display: block;

      @media screen and (min-width: 600px) {
        .button-container {
          float: right;
          max-width: 50%;
        }
      }

      @media screen and (max-width: 600px) {
        .subscribe-container {
          margin: 10em !important;
        }
      }

      .button-container {
        justify-content: center;
        padding: 10px;

        .pill {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 130px;
          border: 3px solid $secondaryColor;
          background-color: $secondaryColor;
          color: $whiteColor;
          height: 40px;
          border-radius: 20px;
          font-weight: 800;
          padding: 0.25rem 1rem;
          text-transform: uppercase;
          font-family: "Averia Sans Libre", sans-serif;

          &:hover {
            border: 3px solid $secondaryColor;
            color: $secondaryColor;
            background-color: $backgroundColor;
          }
        }
      }
    }
  }
}
</style>
